import React from "react";
import QuestionItem from "./QuestionItem";

function QuestionList({ questions, answers = {}, onAnswerChange, validationErrors }) {
  if (!questions || questions.length === 0) {
    return null;
  }

  return (
    <div className="ids-mb-6">
      {questions.map((q, idx) => (
        <QuestionItem
          key={q.questionId}
          question={q}
          index={idx + 1}
          value={answers[q.questionId] ?? ""}
          answers={answers}
          onAnswerChange={onAnswerChange}
          validationErrors={validationErrors}
        />
      ))}
    </div>
  );
}

export default QuestionList;
